import { Suspense, lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const OrganizationsPage = lazy(
  () => import('@/pages/dictionary-organizations/ui/index'),
)

export const Route = createFileRoute('/_protected/dictionary/organizations/')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <OrganizationsPage />
    </Suspense>
  ),
})
